/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTestDto } from './GetTestDto';
import {
    GetTestDtoFromJSON,
    GetTestDtoFromJSONTyped,
    GetTestDtoToJSON,
} from './GetTestDto';

/**
 * 
 * @export
 * @interface GetKeyTestDto
 */
export interface GetKeyTestDto {
    /**
     * 
     * @type {string}
     * @memberof GetKeyTestDto
     */
    id: string;
    /**
     * 
     * @type {GetTestDto}
     * @memberof GetKeyTestDto
     */
    test?: GetTestDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeyTestDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the GetKeyTestDto interface.
 */
export function instanceOfGetKeyTestDto(value: object): value is GetKeyTestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetKeyTestDtoFromJSON(json: any): GetKeyTestDto {
    return GetKeyTestDtoFromJSONTyped(json, false);
}

export function GetKeyTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKeyTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'test': json['test'] == null ? undefined : GetTestDtoFromJSON(json['test']),
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function GetKeyTestDtoToJSON(value?: GetKeyTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'test': GetTestDtoToJSON(value['test']),
        'name': value['name'],
    };
}

